export enum QueryStatus {
    New = 1,
    AssignedToDeptRep = 2,
    QueryAnsweredByDeptRep = 3,
    QueryAnsweredBySponsor = 4,
    Recycled = 5,
    Responded = 6,
    ReOpened = 7,
    DeletedByPartner = 8,
    DeletedByRFCAdmin = 9
}